import * as ApiModels from '@typings/api-models';
import ActionButton from './ActionButton';

type ThisItem = (
  & Pick<ApiModels.Task, 'title'>
  & ApiModels.TaskTypedData
  & { assignees: Array<{ id: string }> }
);

type Props = {
  item: ThisItem;
  userId: string;
  onClick: () => void;
  disabled?: boolean;
};

const DefaultAction: React.FC<Props> = ({
  item,
  userId,
  onClick,
  disabled = false,
}) => {
  const imAssigned = Boolean(item.assignees.find(assignee => assignee.id === userId));

  return (
    <>
      {!imAssigned && <span className="caption">{item.title}</span>}
      <ActionButton
        onClick={onClick}
        disabled={!imAssigned || disabled}
      >
        {imAssigned ? item.title : 'This task is not for you.'}
      </ActionButton>
    </>
  );
};

export default DefaultAction;